<template>
    <div>
        <el-table :data="goodsList"  style="width: 100%; margin-top: 20px" size="medium" max-height="560"
                  :header-cell-style="{fontWeight: 'normal', height: '46px', color: '#666', background: '#F5F5F5'}"
                  @sort-change="sortByEvent"
                  :cell-style="{fontSize: '14px',color: '#333'}">
            <el-table-column label="排名" align="center" width="60">
                <template slot-scope="scope">
                    <div class="ranking" v-if="scope.row.sort === 1 || scope.row.sort === 2 || scope.row.sort === 3">{{scope.row.sort}}</div>
                    <div v-else>{{scope.row.sort}}</div>
                </template>
            </el-table-column>
            <el-table-column label="商品信息" min-width="300">
                <template slot-scope="scope">
                    <div  class="goods-wrapper">
                        <div class="goods-box">
                            <div class="goods-cover">
                                <img :src="scope.row.img ? scope.row.img:require('../../../assets/images/user_img.png')" alt="">
                            </div>
                            <div class="goods-right">
                                <div slot="reference" class="text-overflow-2 goods-title">{{scope.row.brand_info}}</div>
                            </div>
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="turnoverIndex" align="center" label="金额指数" sortable="custom"></el-table-column>1
            <el-table-column prop="volumeIndex" align="center" label="单量指数" sortable="custom"></el-table-column>
            <el-table-column prop="click_num" align="center" label="点击指数" sortable="custom"></el-table-column>
            <el-table-column prop="transaction_conversion" align="center" label="转化指数" sortable="custom"></el-table-column>
            <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                    <el-link :underline="false" class="link-blue-light" @click="toDetail(scope.row)">详情</el-link>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination class="operation-pagination" style="margin: 20px 0 0;"
                       :current-page="listPages.currentPageNum"
                       :page-size="listPages.eachPageNum"
                       :total="listPages.total"
                       layout="prev, pager, next, jumper"
                       @current-change="pagesCurrentChange">
        </el-pagination>
    </div>
</template>

<script>
    import {tranPurchaseDealTop} from '@/utils/apis'
    export default {
        data() {
            return {
                goodsList: [],
                listPages: {
                    currentPageNum: 1,
                    eachPageNum: 10,
                    total: 0,
                },
                brandListTmp: [],
                brandListData:[],
                sortName: '',
                sortType: '',
            }
        },
        mounted() {
            this.getGoodsList()
        },
        methods: {
            sortByEvent(val) {
                this.sortName = val.prop;
                this.sortType = val.order==='ascending' ? 'asc' : 'desc';
                this.getGoodsList()
            },
            // 获取交易榜单列表
            getGoodsList() {
                let param ={
                    paging:1,
                    page:this.listPages.currentPageNum,
                    pageSize:this.listPages.eachPageNum,
                    sort_name: this.sortName,
                    sort_type: this.sortType,
                }
                if (this.$route.query.op_id) {
                    param.op_id = this.$route.query.op_id;
                }
                if (this.$route.query.course_id) {
                    param.course_id = this.$route.query.course_id;
                }
                tranPurchaseDealTop(param).then((res) => {
                    this.goodsList = res.data.list
                    this.listPages.total = res.data.total
                }).catch((err)  => {
                    console.log(err);
                })
            },
            // 详情
            toDetail(row) {
                if (this.$route.query.op_id) {
                    this.$router.push({
                        path: '/student/trainCenter/startTraining/treaddetail',
                        query: {
                            op_id: this.$route.query.op_id,
                            exam_module_id:this.$route.query.exam_module_id,
                            course_id:this.$route.query.course_id,
                            brand:row.brand,
                            goods_id:row.goods_id
                        }
                    })
                } else {
                    this.$router.push({
                        path: '/student/procurement/treadDetail',
                        query: {
                            exam_module_id:this.$route.query.exam_module_id,
                            brand:row.brand,
                            goods_id:row.goods_id
                        }
                    })
                }
            },
            // 切换分页
            pagesCurrentChange(val) {
                this.listPages.currentPageNum = val
                this.getGoodsList()
            },

        }
    }
</script>

<style scoped lang="scss">
    .goods-wrapper {
        .goods-box {
            display: flex;
            align-items: center;
            .goods-cover {
                width: 48px;
                height: 48px;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-right: 10px;
                border: 1px solid #eee;
                box-sizing: border-box;
                img {
                    max-width: 100%;
                    max-height: 100%;
                }
            }
            .goods-right {
                width: 1%;
                flex: 1;
                .goods-title {
                    color: #333;
                    line-height: 18px;
                    transition: all .3s;
                    &:hover {
                        /*color: #FD4446;*/
                    }
                }

            }
        }
    }
    ::v-deep .el-table {
         border: 1px solid #eee;
        .el-table__body-wrapper {
            .el-table__row {
                .ranking {
                    width: 24px;
                    height: 24px;
                    line-height: 24px;
                    text-align: center;
                    font-weight: 500;
                    background-size: cover;
                    display: inline-block;
                }
                &:first-child {
                    .ranking {
                        background: url("../../../assets/images/student/num-001.png") no-repeat center;
                    }
                }
                &:nth-of-type(2) {
                    .ranking {
                        background: url("../../../assets/images/student/num-002.png") no-repeat center;
                    }
                }
                &:nth-of-type(3) {
                    .ranking {
                        background: url("../../../assets/images/student/num-003.png") no-repeat center;
                    }
                }
            }
        }
    }
    .goodInfo-content {
        .info-item {
            margin-top: 20px;
            .item-title {
                font-size: 16px;
                line-height: 40px;
                background: #eee;
                color: #333;
                font-weight: bold;
                padding-left: 10px;
            }
            .item-content {
                margin-top: 10px;
                .attr-list {
                    .item {
                        margin-top: 6px;
                    }
                }
            }
        }
    }
    .operation-pagination {
        padding: 0;
        margin: 30px 0;
        text-align: right;
        .el-pager {
            li.active {
                color: #FD4446;
            }
        }
        .el-pagination__sizes {
            .el-input__inner {
                color: #333;
            }
        }
        .el-pagination__total {
            color: #333;
        }
        .el-pagination__jump {
            color: #333;
        }
    }
    .link-blue-light {
        &.el-link--default {
            color: #1E63F1;
            &:hover {
                color: #6191f5;
            }
            &.is-disabled {
                &:hover {
                    color: #C0C4CC;
                }
            }
        }
    }
</style>